/**
* @namespace lDialog
*/

(function(lDialog, $, undefined) /** @lends lDialog **/ {

  var _dialogInstance;
  var $body;

  var _isArray = Array.isArray || function (obj) {
    return Object.prototype.toString.call(obj) === '[object Array]';
  };
  var _extendOptions = function(options) {
    return $.extend(true, {}, lDialog.defaults, options || {});
  };

  function LDialog(options) {

    if (!$body) {
      $body = $(document.body);
    }

    options = _extendOptions(options);

    this.options = options;

    this.initStructure();
    this.initContent();
  }

  $.extend(LDialog.prototype, /** @lends lDialog.LDialog.prototype */ {

    initStructure: function() {

      var Classes         = this.options.Classes;
      var options         = this.options;
      var $dialog         = $(options.template);
      var $contentTarget  = $dialog.find('.' + Classes.DIALOG_CONTENT_TARGET);
      var $title          = $dialog.find('.' + Classes.DIALOG_TITLE);

      this.$dialog        = $dialog;
      this.$contentTarget = $contentTarget;
      this.$title         = $title;

      if (options.className) {
        this.addClass(options.className);
      }

      this.$dialog.on('click', $.proxy(this.onClick, this));

      $body.append($dialog);
      $body.addClass(Classes.BODY_DIALOG_OPEN);
    },


    replaceDialogContents: function(options) {
      options = _extendOptions(options);
      var hasDifferentTemplate =
        options.template !== this.options.template ||
        options.className !== this.options.className;

      this.options = options;

      if (hasDifferentTemplate) {
        this.$dialog.remove();
        this.initStructure();
      }
      this.initContent();
    },

    initContent: function() {
      this.updateTitle();
      this.updateContent();
      this.updateContentAjax();
    },

    updateTitle: function(title) {
      if (typeof title === 'undefined') {
        title = this.options.title || '';
      }
      this.$title.html(title);
    },

    addClass: function(className) {
      this.$dialog.addClass(className);
    },

    removeClass: function(className) {
      this.$dialog.removeClass(className);
    },

    updateContent: function(content) {
      content = content || this.options.content;
      this.$contentTarget.html(content);

      if (this.options.autofocusFirstFocusableElement) {
        var $autofocus = this.$contentTarget.find('[autofocus]');
        if (!$autofocus.length) {

          // http://dev.w3.org/html5/spec-preview/editing.html#focus-management
          var focusableSelector = [
            'a[href]',
            'link[href]',
            'button:not([disabled])',
            'input:not([type=hidden]):not([disabled])',
            'select:not([disabled])',
            'textarea:not([disabled])'
          ].join(',');

          $autofocus = this.$contentTarget.find(focusableSelector);
        }
        if ($autofocus.length) {
          $autofocus[0].focus();
        }
      }
    },

    updateContentAjax: function(ajaxOptions) {
      ajaxOptions = ajaxOptions || this.options.ajax;
      if (ajaxOptions && ajaxOptions.url) {
        $.ajax(ajaxOptions).done( $.proxy(this.updateContent, this) );
      }
    },

    onClick: function(event) {

      var Classes         = this.options.Classes;
      var $target         = $(event.target);
      var isDismissalItem = $target.is('.' + Classes.DIALOG_DISMISSAL_ITEM);
      var isOverlay       = this.options.closeOnOverlay &&
        $target.is(':not(.' + Classes.DIALOG_CONTAINER_MAIN + ')') &&
        $target.parents().filter('.' + Classes.DIALOG_CONTAINER_MAIN).length === 0;

      if (isDismissalItem || isOverlay) {
        this.close();
      }
    },

    testCanClose: function(onComplete) {

      var shouldClose = this.options.shouldClose;

      if (shouldClose) {

        if (typeof shouldClose === 'function') {
          shouldClose = [shouldClose];
        }
        if (!_isArray(shouldClose)) {
          onComplete();
          return;
        }

        var len = shouldClose.length;
        var i = 0;

        var runQueue = function(continueClosing) {
          if (continueClosing) {
            if (i < len) {
              var next = shouldClose[i];
              i++;
              if (typeof next === 'function') {
                next(runQueue);
              } else {
                runQueue(true);
              }
            } else {
              onComplete();
            }
          } else {
            // Closing cancelled
          }
        };

        runQueue = $.proxy(runQueue, this);
        runQueue(true);

      } else {
        onComplete();
      }

    },

    close: function(onComplete) {
      onComplete = onComplete || $.proxy(this.doClose, this);
      this.testCanClose(onComplete);
    },

    executeBeforeCloseCallbacks: function() {
      var beforeClose = this.options.beforeClose;

      if (beforeClose) {
        if (typeof beforeClose === 'function') {
          beforeClose = [beforeClose];
        }
        if (_isArray(beforeClose)) {
          for (var i = 0, len = beforeClose.length; i < len; i++) {
            var fn = beforeClose[i];
            if (typeof fn === 'function') {
              fn();
            }
          }
        }
      }
    },

    doClose: function() {
      var Classes = this.options.Classes;

      this.executeBeforeCloseCallbacks();

      $body.removeClass(Classes.BODY_DIALOG_OPEN);
      this.$dialog.remove();
      _dialogInstance = null;
    }
  });

  /**
   * @namespace
   * @memberOf lDialog
  */
  var defaults = {

    /** @default */
    closeOnOverlay: true,

    /** @default */
    autofocusFirstFocusableElement: true,

    /**
    @default See example
    @example
    <div class="l-dialog-loading">Loading…</div>
    */
    content: '<div class="l-dialog-loading">Loading…</div>',

    /**
    @default See example
    @example
    <aside class="l-dialog" role="dialog">
      <div class="l-dialog-container-main js-l-dialog-container-main">
        <div class="l-dialog-container-header">
          <h1 class="l-dialog-title js-l-dialog-title"></h1>
          <button type="button" class="l-dialog-close js-l-dialog-dismissal-item"></button>
        </div>
        <div class="l-dialog-content-target js-l-dialog-content-target"></div>
      </div>
    </aside>
    */
    template:
    '<aside class="l-dialog" role="dialog">' +
      '<div class="l-dialog-container-main js-l-dialog-container-main">' +
        '<div class="l-dialog-container-header">' +
          '<h1 class="l-dialog-title js-l-dialog-title"></h1>' +
          '<button type="button" class="l-dialog-close js-l-dialog-dismissal-item"></button>' +
        '</div>' +
        '<div class="l-dialog-content-target js-l-dialog-content-target"></div>' +
      '</div>' +
    '</aside>',

    /**
     * @enum {String}
     */
    Classes: {
      /**
       * Class applied to the body while a dialog is open
       * @default
       */
      BODY_DIALOG_OPEN: 'l-dialog-open',

      /**
       * Class noting main visible dialog contents. Used to determine if your
       * clicks are "inside" the dialog or on the overlay
       * @default
       */
      DIALOG_CONTAINER_MAIN: 'js-l-dialog-container-main',

      /**
       * Class that, when clicked, will close the dialog. Typically applied to the close button.
       * @default
       */
      DIALOG_DISMISSAL_ITEM: 'js-l-dialog-dismissal-item',

      /**
       * Class noting the title element
       * @default
       */
      DIALOG_TITLE: 'js-l-dialog-title',

      /**
       * Class noting the loaded content's intended container
       * @default
       */
      DIALOG_CONTENT_TARGET: 'js-l-dialog-content-target'
    }
  };

  lDialog.defaults = defaults;



  /**
   * Closes the open dialog
   */
  lDialog.close = function() {
    if (_dialogInstance) {
      _dialogInstance.close();
    }
  };

  /**
   * Displays a dialog for the given options. If a dialog is already open,
   * it is effectively closed (triggering the {@link LDialogOptions.shouldCloseCallback shouldClose routine})
   * and a new one created for you. Your options get merged with the site's
   * {@link lDialog.defaults default options}
   * @param  {Object} options LDialogOptions Object
   */
  lDialog.open = function(options) {
    if (_dialogInstance) {
      _dialogInstance.close(function() {
        _dialogInstance.replaceDialogContents(options);
      });
    } else {
      _dialogInstance = new LDialog(options);
    }
  };

  /**
   * Updates dialog title
   * @param  {String} title Title string
   */
  lDialog.updateTitle = function (title) {
    if (_dialogInstance) {
      _dialogInstance.updateTitle(title || '');
    }
  };

  /**
   * Adds the specified class(es) to the dialog
   * @param  {String} className One or more space-separated classes to be
   * added to the class attribute of the main dialog container
   */
  lDialog.addClass = function (className) {
    if (_dialogInstance) {
      _dialogInstance.addClass(className);
    }
  };

  /**
   * Removes the specified class(es) from the dialog
   * @param  {String} className One or more space-separated classes to be
   * removed from the class attribute of the main dialog container
   */
  lDialog.removeClass = function (className) {
    if (_dialogInstance) {
      _dialogInstance.removeClass(className);
    }
  };

})(window.lDialog = window.lDialog || {}, jQuery);



/** @namespace LDialogOptions */

/**
 * Options object for a given dialog.
 * @memberOf LDialogOptions
 * @typedef  {Object}         LDialogOptions
 * @property {String}         [title]          - Dialog title string
 * @property {String}         [content]        - HTML content to display
 * @property {Function|Array} [shouldClose]    - One (or an array of) {@link LDialogOptions.shouldCloseCallback}
 * @property {Object}         [ajax]           - {@link http://api.jquery.com/jQuery.ajax/#jQuery-ajax-settings jQuery Ajax settings}.
 *                                               If present, an ajax request will be made to the given url and the dialog contents will be
 *                                               updated with response text
 * @property {String}         [className]      - Class to apply to the main container
 * @property {boolean}        [closeOnOverlay] - Indicates whether clicking the background overlay should close the dialog
 * @property {boolean}        [autofocusFirstFocusableElement] - After setting content, the first focusable element will be focused.
 *                                               :autofocus takes precedence
 * @property {String}         [template]       - HTML template string for creating the dialog structure
 * @property {Object}         [Classes]        - Object designating CSS classes used by LDialog. See {@link lDialog.defaults.Classes}
 *                                               for default values and descriptions.
 * @property {Function|Array} [beforeClose]    - Function (or array of functions) to call before the dialog closes
 *
 * @example
 * // Basic usage
 * {
 *   title: 'Current Users',
 *   content: '<p>Loading Current Users</p>', // This will show initially
 *   ajax: {
 *     url: '/h/api/DialogContent' // Dialog contents will be updated with response text
 *   }
 * }
 *
 * @example
 * // Multiple shouldClose callbacks:
 * {
 *   title: 'My Dialog',
 *   content: '<h2>Hey Buddy</h2>',
 *   shouldClose: [
 *     function(close) {
 *       // test some stuff you have on hand
 *       if (clearToClose) {
 *         close(true);
 *       } else {
 *         close(false);
 *       }
 *     },
 *     function(close) {
 *       // do an async operation
 *       setTimeout(function() {
 *         close(true);
 *       }, 3000);
 *     }
 *   ]
 * }
 */

/**
 * Callback to determine whether or not the dialog should close. Calling <code>close</code>
 * with <code>false</code> tells LDialog to cancel the close process
 * @callback shouldCloseCallback
 * @memberOf LDialogOptions
 * @param {Function} close - Function to call when your operation is complete
 *
 * @example
 * function(close) {
 *   var confirm = window.confirm('Are you sure you want to close this dialog?');
 *   if (confirm) {
 *     close(true);
 *   } else {
 *     close(false);
 *   }
 *  }
 */